var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-builder-wrapper"},[_c('h5',[_vm._v("This is a manual component")]),_c('p',[_vm._v("You can't do shit here!")])])}]

export { render, staticRenderFns }